import React from "react";
import { ENROLLMENT_PAGES } from "../../constants/enrollment";

import PageStepperItem from "./PageStepperItem";

const PageStepper = ({ currentPage, className }: { currentPage: number; className?: string }) => {
  return (
    <div className={`page-stepper spacing-top-medium spacing-right-large v2 ${className || ''}`}>
      <ul className="unstyled pl-0 min-w-200">
        {ENROLLMENT_PAGES.map((page, index) => {
          const isActive = currentPage === page.page_number;
          const isCompleted = currentPage > page.page_number;
          return (
            <PageStepperItem
              key={page.page_number}
              pageNumber={page.page_number}
              pageNumberToDisplay={page.page_number_display}
              label={page.label}
              isActive={isActive}
              isCompleted={isCompleted}
              index={index}
            />
          )
        })}
      </ul>
    </div>
  );
}

export default PageStepper;